<div>
    <h2 mat-dialog-title>
        {{title}}
        <div class="wb-close-button">
            <button (click)="close()" *ngIf="showCloseButton">
                <i class="material-icons">close</i>
            </button>
        </div>
    </h2>
    <mat-dialog-content *ngIf="!dataService.generatingRateTable && !generatingRateTableComplete">
        <div class="grid-x">
            <div class="cell full-width">
                <h3>Deliver Rates As</h3>
                <div class="controls-multi inline-controls">
                    <ul>
                        <li *ngFor="let exportType of exportTypes" class="export-types"
                            [ngClass]="{'active-control' : exportType.IsSelected}"
                            (click)="updateExportType(exportType)">
                            <span [attr.data-qaauto]="exportType.Name">{{exportType.Name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="cell full-width">
                <h3>Delivery Options</h3>
                <div class="controls-multi inline-controls">
                    <ul>
                        <li *ngFor="let deliveryType of deliveryTypes" class="delivery-types"
                            [ngClass]="{'active-control' : deliveryType.IsSelected}"
                            (click)="updateDeliveryType(deliveryType)">
                            <span [attr.data-qaauto]="deliveryType.Name">{{deliveryType.Name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <mat-form-field id="email" class="example-chip-list fullwidth email-chips" *ngIf="showEmailOption">
            <mat-chip-list #chipList>
                <mat-chip *ngFor="let email of emails" (removed)="removeEmail(email)">
                    {{email}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input placeholder="Email" id="email" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addEmailForExport($event)">

                <mat-error *ngIf="!isValidEmail">Invalid Email.</mat-error>
            </mat-chip-list>

        </mat-form-field>
        <p class="small" style="color:red" *ngIf="showEmailOption && emails.length == 0"> Please add an email address.
        </p>
        <p class="small" *ngIf="showEmailOption">(Please type an email address and press enter. You can enter additional
            addresses by
            pressing enter between each entry)</p>
    </mat-dialog-content>
    <div *ngIf="dataService.generatingRateTable">
        <div>
            <mat-progress-bar color="accent" mode="buffer" [value]="generatingRateTablePercent" bufferValue="0">
            </mat-progress-bar>
            <div class="cell full-width">
                {{generatingRateTablePercent}}%
            </div>
        </div>
    </div>
    <mat-dialog-content *ngIf="generatingRateTableComplete">
        <div class="grid-x">
            <div class="cell full-width" *ngIf="!dataService.isFromBrokerMobileApp()">
                <p> Your Rate Table(s) have been generated.</p>
            </div>
            <div class="cell full-width" *ngIf="dataService.isFromBrokerMobileApp()">
                <span>Your Rate Table(s) have been generated.</span>
                <p>Please click the Back button to get back to Broker Mobile Dashboard.</p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="text-center">
        <button *ngIf="!generatingRateTableComplete && !dataService.generatingRateTable"
            class="mat-raised-button mat-primary" (click)='generate()'
            [disabled]="disableGenerateBtn()">Generate</button>
        <button *ngIf="generatingRateTableComplete && !dataService.isFromBrokerMobileApp()"
            class="button mat-raised-button" (click)='redirect()'>Ok</button>
    </mat-dialog-actions>
</div>